/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_Setup_HintInputs */

const cs_ebr_conn_setup_hint = /** @type {(inputs: Ebr_Conn_Setup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte adresu exportu eBrány vaší kanceláře. Uloží se šifrovaně a po uložení už ji nikdo neuvidí.`)
};

const en_ebr_conn_setup_hint = /** @type {(inputs: Ebr_Conn_Setup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your office's eBrána export address. It is stored encrypted and nobody can see it after saving.`)
};

/**
* | output |
* | --- |
* | "Paste your office's eBrána export address. It is stored encrypted and nobody can see it after saving." |
*
* @param {Ebr_Conn_Setup_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_setup_hint = /** @type {((inputs?: Ebr_Conn_Setup_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Setup_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_setup_hint(inputs)
	return cs_ebr_conn_setup_hint(inputs)
});